var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 85.34h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M512 85.334v166.69L0 256.175V85.334z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M315.362 300.525L256 293.104l-59.362 7.421v-89.044h118.724z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 263.427,
  r: 29.682,
  fill: "#0052b4"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 263.427,
  r: 14.84,
  fill: "#a2001d"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M233.739 226.321h44.522L256 248.582z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M248.576 241.166h14.84v44.522h-14.84z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M279.746 281.232h-47.492l-35.616 19.293h118.724z"
})));

export default SvgHt;